module.exports = __webpack_public_path__ + "img/logo-bca.6fa5db14.png";